<script lang="ts">
  import { onDestroy, onMount } from "svelte";
  import type { DebtorPaymentMethod } from "../../../../apis/parkito";
  import { Form, Validate } from "../../../lib/validation_next";
  import ValSelect from "../../ValSelect.svelte";
  import ValInputField from "../../ValInputField.svelte";
  import CustomButton from "../../CustomButton.svelte";
  import { Hor, Spacer, Ver } from "$components";
  import { Toast } from "$components";
  import {
    getPaymentMethodType,
    paymentMethodIsAutogiro,
  } from "../../../utils/validation";
  import ValCheckbox from "../../ValCheckbox.svelte";
  import { ModalDialog } from "$components";
  import Separator from "../../Separator.svelte";
  import DebtorAutogiroAgreement from "../../../../projects/dpo/components/debtors/DebtorAutogiroAgreement.svelte";

  export let paymentMethod: DebtorPaymentMethod | undefined | null =
    undefined;
  export let submitForm: (params: DebtorPaymentMethod) => void;
  let showAutogiroAgreement = false;

  // Payment method
  const paymentMethodChoices = [
    { label: "Faktura", value: "invoice", disabled: false },
    { label: "Autogiro", value: "autogiro", disabled: false },
  ];

  const paymentMethodIndex = paymentMethod
    ? paymentMethodChoices.findIndex(
      (choice) => choice.value === getPaymentMethodType(paymentMethod),
    )
    : 0;

  const paymentMethodSelect = Form.multiSelect(
    paymentMethodChoices,
    paymentMethodChoices[paymentMethodIndex],
  );

  const autogiroAccountNr = Form.field(
    Validate.required().and(Validate.len(0, 32)),
    paymentMethodIsAutogiro(paymentMethod)
      ? paymentMethod.autogiro.accountNr
      : "",
  );
  const autogiroClearingNr = Form.field(
    Validate.required().and(Validate.len(0, 12)),
    paymentMethodIsAutogiro(paymentMethod)
      ? paymentMethod.autogiro.clearingNr
      : "",
  );
  const autogiroBankName = Form.field(
    Validate.required().and(Validate.len(0, 64)),
    paymentMethodIsAutogiro(paymentMethod)
      ? paymentMethod.autogiro.bankName ?? ""
      : "",
  );
  let autogiroAgreements = Form.checkbox(
    Validate.boolean(),
    paymentMethodIsAutogiro(paymentMethod),
  );

  const autogiroForm = Form.object({
    autogiro: Form.nest(
      Form.object({
        accountNr: autogiroAccountNr,
        clearingNr: autogiroClearingNr,
        bankName: autogiroBankName,
      }),
    ),
  });

  const paymentMethodFields = {
    invoice: Form.fixed("invoice" as DebtorPaymentMethod),
    autogiro: Form.nest(autogiroForm),
  };
  const form = Form.oneOf(paymentMethodSelect, paymentMethodFields);

  onMount(() => {});

  onDestroy(() => {});

  const requestFormSubmit = async () => {
    if (!$form.res.isOk()) {
      Toast.error("Formuläret innehåller fel");
      return;
    }
    const formdata = $form.res.value;

    submitForm(formdata);
  };
</script>

<Ver>
  <ValSelect
    name="delivery-method"
    field={paymentMethodSelect}
  />
  {#if     $paymentMethodSelect.res.isOk() &&
      $paymentMethodSelect.res.value === "autogiro"}
    <ValInputField
      name="autogiro-clearing-nr"
      field={autogiroClearingNr}
      label="Clearing-nr*"
      placeholder="Clearing-nr"
    />
    <ValInputField
      name="autogiro-account-nr"
      field={autogiroAccountNr}
      label="Kontonummer*"
      placeholder="Kontonummer"
    />
    <ValInputField
      name="autogiro-bank-name"
      field={autogiroBankName}
      label="Betaltjänsteleverantör/bank*"
      placeholder="Bank"
    />
    <p class="ml-[16px] my-[8px]">
      <button
        on:click|preventDefault={(e) => {
          showAutogiroAgreement = true;
        }}
        class="underline"
      >
        Medgivande till betalning via Autogiro
      </button>
    </p>
    <ValCheckbox
      name="autogiro-agreement"
      field={autogiroAgreements}
      label="Jag har läst och godkänner villkoren för autogiro"
    />
  {:else if     $paymentMethodSelect.res.isOk() &&
      $paymentMethodSelect.res.value === "invoice"}
    <p></p>
  {/if}

  <Hor>
    <CustomButton
      disabled={!($form.res.isOk() && $form.hasChanged) ||
        // If autogiro is selected and agreements are not checked
        ($paymentMethodSelect.res.isOk() &&
          $paymentMethodSelect.res.value === "autogiro" &&
          $autogiroAgreements.res.isOk() &&
          $autogiroAgreements.res.value === false)}
      type="primary"
      onClick={requestFormSubmit}
    >Uppdatera</CustomButton>
  </Hor>
</Ver>

<!-- Add DebtorUser -->
{#if showAutogiroAgreement}
  <ModalDialog onBackdropPressed={() => (showAutogiroAgreement = false)}>
    <div class="px-[24px] py-[24px] max-mobile:px-[16px]">
      <h2 class="text-[#181818] text-[18px]">Autogiromedgivande</h2>
    </div>
    <Separator />
    <div class="px-[24px] py-[16px] max-mobile:px-[16px]">
      <DebtorAutogiroAgreement customClass="max-w-[480px]" />
      <div class="flex pt-[24px] justify-end">
        <CustomButton
          type="ghost"
          onClick={() => (showAutogiroAgreement = false)}
          customClass="mr-[8px]"
        >Stäng</CustomButton>
      </div>
    </div>
  </ModalDialog>
{/if}
